var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"churn-flow"}},[(!_vm.openSurvey)?_c('churn-goodbye-page',{attrs:{"start-survey":_vm.startSurvey}}):_c('churn-survey')],1)}
var staticRenderFns = []

export { render, staticRenderFns }